/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */

export type VoteDecision = typeof VoteDecision[keyof typeof VoteDecision];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VoteDecision = {
  Approve: 'Approve',
  Reject: 'Reject',
  Abstain: 'Abstain',
} as const;
